import api from './api';

export const BELL_NOTIFICATIONS_PAGE_SIZE = 5;
export const DEFAULT_ITEMS_PER_PAGE = 10;
export const ITEMS_PER_PAGE_OPTIONS = [10, 20, 50, 100];

const normalizePaginated = (response) => ({
  data: response.data?.data || [],
  pageIndex: response.data?.pageIndex ?? 0,
  itemsPerPage: response.data?.itemsPerPage ?? DEFAULT_ITEMS_PER_PAGE,
  totalItems: response.data?.totalItems ?? 0,
});

export const getStaffInAppNotifications = async (
  storeId,
  { pageIndex = 0, itemsPerPage = DEFAULT_ITEMS_PER_PAGE } = {},
) => {
  const response = await api.get('/staff-in-app-notifications', {
    params: { pageIndex, itemsPerPage },
    _authContext: 'management',
    _storeId: storeId,
  });
  return normalizePaginated(response);
};

const toUnreadCount = (value) => {
  const count = Number(value);
  return Number.isInteger(count) && count >= 0 ? count : 0;
};

export const getStaffInAppNotificationUnreadCount = async (storeId) => {
  const response = await api.get('/staff-in-app-notifications/unread-count', {
    _authContext: 'management',
    _storeId: storeId,
  });
  const data = response.data;
  if (typeof data === 'number') {
    const count = toUnreadCount(data);
    return { count, badgeCount: count };
  }

  const count = toUnreadCount(data?.count);
  const badgeCount = data?.badgeCount == null ? count : toUnreadCount(data.badgeCount);
  return { count, badgeCount };
};

export const markStaffInAppNotificationRead = async (notificationId, storeId) => {
  await api.post(`/staff-in-app-notifications/${notificationId}/read`, null, {
    _authContext: 'management',
    _storeId: storeId,
  });
};

export const markAllStaffInAppNotificationsRead = async (storeId) => {
  await api.post('/staff-in-app-notifications/read-all', null, {
    _authContext: 'management',
    _storeId: storeId,
  });
};

export const markStaffChatNotificationsRead = async (conversationId, storeId) => {
  const response = await api.post(
    `/staff-in-app-notifications/conversations/${conversationId}/read`,
    null,
    {
      _authContext: 'management',
      _storeId: storeId,
    },
  );
  const data = response.data;
  if (typeof data === 'number') {
    const count = toUnreadCount(data);
    return { count, badgeCount: count };
  }

  const count = toUnreadCount(data?.count);
  const badgeCount = data?.badgeCount == null ? count : toUnreadCount(data.badgeCount);
  return { count, badgeCount };
};
